import React from 'react';
import IndividualServiceRegistration from '../IndividualServiceRegistration/IndividualServiceRegistration';

const Register = () => {
    return (
        <div>
            <IndividualServiceRegistration/>
        </div>
    );
};

export default Register;